import { Logo } from './Logo';

// The three arrows alone. Kept as the name the public pages already import:
// they size it with a square `className` (30px, 36px...), so the mark is
// centred in that box rather than stretched. New code should use <Logo>.
export function BrandMark({ className }: { className?: string | undefined }) {
    return <Logo variant="mark" centered className={className} />;
}
